import { defineMessages } from 'react-intl';

export default defineMessages({
  // main-menu
  configuration: {
    id: 'Header.config.school-coach.configuration',
    defaultMessage: 'Configuration',
  },
  students: {
    id: 'school-coach.students',
    defaultMessage: 'Étudiants',
  },

  // usernav
  settings: {
    id: 'Header.config.fdr-coach.settings',
    defaultMessage: 'Paramètres',
    description: 'item setting dans la usernav',
  },
  logout: {
    id: 'Header.config.fdr-coach.logout',
    defaultMessage: 'Se déconnecter',
    description: 'item deconnexion dans la usernav',
  },
});
